import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import React, { forwardRef } from "react"
import { NavLink, NavLinkProps } from "react-router-dom"

import I18n from "@/i18n"

type LinkProps = NavLinkProps & {
  to: string
  className?: string
  [key: string]: any
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ className, to, ...props }, ref) => (
  <NavLink className={({ isActive }) => `${className} ${isActive ? "" : "opacity-50"} `} ref={ref} to={to} {...props} />
))
Link.displayName = "Link"

type NavIconProps = {
  to: string
  i18nKey: string
  end?: boolean
  children: React.ReactNode
  "data-testid"?: string
}

const NavIcon: React.FC<NavIconProps> = ({ to, i18nKey, end, children, "data-testid": testId }) => {
  const title = I18n.t(i18nKey)
  return (
    <Tooltip title={title} placement="right">
      <IconButton color="inherit" component={Link} to={to} end={end} aria-label={title} data-testid={testId}>
        {children}
      </IconButton>
    </Tooltip>
  )
}

export default NavIcon
